import React from 'react';
import AddNewJobForm from '../../components/AddNewJobForm/AddNewJobForm';

const AddNewJob = () => {

    // rendering the add new job page here
    return (
        <>
            <AddNewJobForm />
        </>
    );
};

export default AddNewJob;